import BulkActionCommon from './BulkActionCommon';

export default BulkActionCommon;
